<template>
  <div class="consignor-train">
    <div class="nav">
      <el-form :model="form" label-width="80px" :inline="true"  class="demo-form-inline flex1">
        <el-form-item label="供应商:">
          <el-input v-model="form.supplierName" size="mini" placeholder="请输入托运商名称"></el-input>
        </el-form-item>
        <el-form-item label="培训方式:">
          <el-input v-model="form.trainMode" size="mini" placeholder="请输入培训方式"></el-input>
        </el-form-item>
        <el-form-item label="培训时间:">
          <el-date-picker v-model="form.startDate" size="mini" style="width:150px" value-format="yyyy-MM-dd" @change="dateChange" type="date" placeholder="开始日期"/>
          <span style="display:inline-block;width:15px;text-align:center;font-size:18px">-</span>
          <el-date-picker v-model="form.endDate" size="mini" style="width:150px" value-format="yyyy-MM-dd" @change="dateChange" type="date" placeholder="结束日期"/>
        </el-form-item>
        <el-form-item label="状态:">
          <el-select v-model="form.status" filterable size="mini" placeholder="请选择状态">
            <el-option label="全部" value=""></el-option>
            <el-option label="待审核" value="1"></el-option>
            <el-option label="已通过" value="2"></el-option>
            <el-option label="已拒绝" value="3"></el-option>
            <el-option label="已取消" value="4"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button size="small" class="searchBtn" @click="searchBtn">查询</el-button>
          <el-button size="small" class="resetBtn" @click="resetBtn">重置</el-button>
          <el-button size="small" type="primary" @click="addBtn">新增</el-button>
        </el-form-item>

      </el-form>
    </div>
    <div class="content">
      <div class="tableContainer">
        <el-table
          v-loading="tableLoad"
          :data="TableDatas"
          style="width: 100%"
          border
          stripe
           :header-cell-style="{color:'#3B3B3B','font-size':'13px','height':'48px',background:'#E8E8E8'}"
          :cell-style="{'color':'#7F7F7F','font-size':'13px','height':'52px',}"
        >
          <el-table-column label="序号" align="center" width="50px">
            <div slot-scope="scope">{{scope.$index+1}}</div>
          </el-table-column>
          <el-table-column prop="supplierName" label="托运商" align="center"/>
          <el-table-column prop="trainMode" label="培训方式" align="center"/>
          <el-table-column prop="trainTime" label="培训时间" align="center"/>
          <el-table-column prop="trainSite" label="培训地点" align="center"/>
          <el-table-column prop="createTime" label="添加时间" align="center">
            <template slot-scope="scope">
              {{scope.row.createTime | formatTime}}
            </template>
          </el-table-column>
          <el-table-column prop="stateStr" label="状态" align="center"/>
          <el-table-column label="操作" width="250" align="center">
            <template slot-scope="scope">
              <div style="display:flex;align-items:center;padding-left: 10px">
                <el-button size="mini" class="searchBtn" type="primary" @click="detailClick(scope.row)">详情</el-button>
                <el-button size="mini" class="yellow-bg"
                           @click="modifyClick(scope.row)"
                           v-if="scope.row.state !==4 &&scope.row.state !==2 ">修改
                </el-button>
                <el-button size="mini" type="danger" @click="rejectClick(scope.row)"
                           v-if="scope.row.state!==4 &&scope.row.state !==2">取消申请
                </el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="paginationContainer">
        <el-pagination
          background
          :page-sizes="[10, 20, 30, 40]"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          @size-change="contractSizeChange"
          @current-change="contractCurrentChange"
          :current-page.sync="form.page"
          :page-size="form.rows"
        />
      </div>
    </div>
    <el-dialog :title="dialogTitle" :visible.sync="addflag"  width='700px' center @close="dialogClose">
      <div class="add">
        <div class="baseInfo">

          <div class="baseInfoContent">

            <el-form :model="modifyData" label-width="110px" label-position="right" :rules="rules" ref="ruleForm" class="demo-ruleForm">
              <div-border label="基础信息" prop="plan">
                <div class="yang">
                  <el-form-item label="培训时间:"  prop="trainTime" style="margin-top: 15px">
                    <el-date-picker
                      v-model="modifyData.trainTime"
                      type="datetime"
                      size="mini"
                      placeholder="请输入培训时间"
                      value-format="yyyy-MM-dd HH:mm:ss">
                    </el-date-picker>
                    <!--                    <el-input v-model="modifyData.name" size="mini" placeholder="请简单描述扣款原由"></el-input>-->
                  </el-form-item>
                  <el-form-item label="培训方式:" prop="trainMode" >
                    <el-input v-model="modifyData.trainMode" size="mini" placeholder="请输入培训方式"></el-input>
                  </el-form-item>
                  <el-form-item label="培训地点:" prop="trainMode" >
                    <el-input v-model="modifyData.trainSite" size="mini" placeholder="请输入培训地点"></el-input>
                  </el-form-item>
                  <el-form-item label="培训内容:" prop="trainContent">
                    <el-input
                      type="textarea"
                      :autosize="{ minRows: 2, maxRows: 6}"
                      placeholder="请输入培训内容"
                      v-model="modifyData.trainContent" size="mini" >
                    </el-input>
                  </el-form-item>


                  <el-form-item label="培训原因:" prop="trainReason">
                    <el-input
                      type="textarea"
                      :autosize="{ minRows: 2, maxRows: 6}"
                      placeholder="请输入培训原因"
                      v-model="modifyData.trainReason" size="mini">
                    </el-input>
                  </el-form-item>


                </div>


              </div-border>

              <div-border label="选择供应商" class="tablesConter">
                <el-table :data="modifyData.shippers" style="margin: 20px;width: 93%;" border stripe
                          size="mini"
                          :header-cell-style="{'color':'#7F7F7F','font-size':'13px','height':'48px','background-color':' #E8E8E8'}"
                          :cell-style="{'color':'#7F7F7F','font-size':'13px','height':'52px',}">
                  <el-table-column type="index" :index="tableIndexMethod" label="序号" width="50"
                                   align="center"/>
                  <el-table-column label="供应商名称" align="center" prop="supplierName">
                    <template slot-scope="scope" >
                      <el-form-item label-width="0px" :prop="'shippers['+scope.$index+'].supplierName'"
                                    :rules="rules.supplierName">

                          <el-cascader
                            ref="areaCascader"
                            size="mini" filterable
                            :options="options2"
                            v-model="scope.row.supplierName"
                            @active-item-change="handleItemChange"
                            @change="handleChange(scope.row.supplierName)"
                            :props="props"
                          ></el-cascader>
                      </el-form-item>
                    </template>
                  </el-table-column>
                  <el-table-column label="培训人员数量" align="center" prop="participantsNum">
                    <template slot-scope="scope">
                      <el-form-item label-width="0px" :prop="'shippers['+scope.$index+'].participantsNum'"
                                    :rules="rules.participantsNum">
                        <el-input size="mini" placeholder="请输入数量" v-model="scope.row.participantsNum"></el-input>
                      </el-form-item>
                    </template>

                  </el-table-column>
                  <el-table-column label="操作" align="center">
                    <template slot-scope="scope">
                      <i class="el-icon-error" @click="deles_production(scope.$index,1)"
                         v-if="modifyData.shippers.length > 1" style="font-size: 26px;"></i>
                      <span v-else>--</span>
                    </template>
                  </el-table-column>
                  <div slot="append" style="padding:9px" >

                    <span  class="append" style="margin:10px" @click="add_production(1)">新增材料</span>
                  </div>

                </el-table>


              </div-border>

              <div-border label="选择我司培训人" class="tablesConter">
                <el-table :data="modifyData.trainer" style="margin: 20px;width: 93%;" border stripe
                          size="mini"
                          :header-cell-style="{'color':'#7F7F7F','font-size':'13px','height':'48px','background-color':' #E8E8E8'}"
                          :cell-style="{'color':'#7F7F7F','font-size':'13px','height':'52px',}">
                  <el-table-column type="index" :index="tableIndexMethod" label="序号" width="50"
                                   align="center"/>
                  <el-table-column label="所属部门" align="center" prop="depName">
                    <template slot-scope="scope">
                      <el-form-item label-width="0px" :prop="'trainer['+scope.$index+'].depName'"
                                    :rules="rules.depName">
                        <el-select placeholder="请选择" size="mini" v-model="scope.row.depName"
                                   value-key="id" filterable 
                                   @change="depNameChange(scope.$index,scope.row.depName)">
                          <el-option v-for="(item,index) in depNameList" :key="`${index}b`"
                                     :label="item.depNm" :value="item"></el-option>
                        </el-select>
                      </el-form-item>
                    </template>
                  </el-table-column>
                  <el-table-column label="员工姓名" align="center" prop="empName">
                    <template slot-scope="scope" >
                      <el-form-item label-width="0px" :prop="'trainer['+scope.$index+'].empName'"
                                    :rules="rules.empName">
                        <el-select  placeholder="请选择" filterable size="mini" v-model="scope.row.empName" value-key="id">
                          <el-option v-for="(item,index) in modifyData.trainer[scope.$index].empNameList" :key="`${index}e`"
                                     :label="item.name" :value="item"></el-option>
                        </el-select>
                      </el-form-item>
                    </template>
                  </el-table-column>
                  <el-table-column label="操作" align="center">
                    <template slot-scope="scope">
                      <i class="el-icon-error" @click="deles_production(scope.$index,2)"
                         v-if="modifyData.trainer.length > 1" style="font-size: 26px;"></i>
                      <span v-else>--</span>
                    </template>
                  </el-table-column>
                  <div slot="append" style="padding:9px">

                    <span class="append" style="margin:10px" @click="add_production(2)">新增材料</span>
                  </div>

                </el-table>


              </div-border>

            </el-form>
            <div class="btnContainer">
              <el-button size="medium" class="searchBtn" :loading="addLoad" @click="addClick">{{dilogNumber===1 ? "添加" :"修改"}}</el-button>
              <el-button size="medium" class="resetBtn" @click="dialogClose">关闭</el-button>
            </div>
          </div>

        </div>

      </div>
<!--      <el-dialog :visible.sync="dialogVisible" append-to-body >-->
<!--        <img width="100%" :src="dialogImageUrl" alt="">-->
<!--      </el-dialog>-->
    </el-dialog>

    <el-dialog title="详情" :visible.sync="detailDialogVisible" width='623px' center>
      <div class="detail">
        <div class="baseInfo">
          <div class="baseInfoTitle">
            <div class="line"/>
            <span>基础信息</span>
            <p>{{detailData.stateStr}}</p>
          </div>
          <div class="baseInfoContent">
            <el-form :model="detailData"  label-position="left">
              <el-form-item label="培训时间:">
                <span>{{detailData.trainTime}}</span>
              </el-form-item>
              <el-form-item label="培训方式:">
                <span>{{detailData.trainMode}}</span>
              </el-form-item>
              <el-form-item label="培训地点:">
                <span>{{detailData.trainSite}}</span>
              </el-form-item>
              <el-form-item label="培训内容:">
                <span>{{detailData.trainContent}}</span>
              </el-form-item>
              <el-form-item label="培训原因:">
                <span>{{detailData.trainReason}}</span>
              </el-form-item>
              <el-form-item label="培训供应商:">
                <span>{{detailData.supplierName}}</span>
              </el-form-item>
              <el-form-item label="我司培训人员:">
                <span>{{detailData.empName}}</span>
              </el-form-item>
<!--              <el-form-item label="备注:">-->

<!--                <div class="center-f">-->
<!--                  <img src="">-->
<!--                </div>-->
<!--              </el-form-item>-->

            </el-form>
          </div>
          <div class="operation">
            <div class="operationTitle">
              <div class="line"/>
              <span>审核信息</span>
            </div>
            <div class="operationTable">
              <steps :step-data="stepData" :step-state="stepState"/>
            </div>
          </div>
        </div>

      </div>

    </el-dialog>
  </div>
</template>

<script>
  import {
    baseUrl,
    baseImgUrl
  } from "@/config/env";
  import uploadImg from "@/components/uploadImg";
  import divBorder from "@/components/divBorder";
  import steps from "@/components/steps";
  import {
    formatTime
  } from "@/config/mUtils";
  import {
    trainRecordPageList,
    trainRecordDetail,
    trainRecordCancelApplyFor,
    trainRecordAdd,
    trainRecordUpdate
  } from "@/service/contract";
  import {
    qryDepartment
  }from "@/service/basicfile"
  import {
    empDeptListByEmpName
  }from "@/service/audit"
  import {highwayLineSelectList, highwayLineSelectWaterSupplier} from "@/service/financial";
  import {shipDeployPublicSelectPort} from "@/service/vehiclelog";
  export default {
    components: {
      uploadImg,
      divBorder,
      steps
    },

    data() {
      let validshippers = (rule, value, callback) => {
        if (this.$refs.shipperRef.length >1){
          this.$refs.shipperRef.forEach((item)=>{
            if (item.value ==="") return callback(new Error("托运商不能为空"));
          })
        }else {
          if (this.$refs.shipperRef[0].value==="") return callback(new Error("托运商不能为空"));
        }
      };
      let  validtraine = (rule, value, callback) => {
        if (this.$refs.traineRef.length >1){
          this.$refs.traineRef.forEach((item)=>{
            if (item.value ==="") return callback(new Error("我司培训人不能为空"));
          })
        }else {
          if (this.$refs.traineRef[0].value ==="") return callback(new Error("我司培训人不能为空"));
        }
      };
      return {
        form:{
          supplierName:"",
          trainMode:"",
          startDate:"",
          endDate:'',
          status:"",
          page:1,
          rows:10,
        },
        total:0,
        tableLoad:false,
        TableDatas:[],
        detailDialogVisible:false,
        detailData:{},
        modifyData:{
          trainTime:'',
          trainMode:'',
          trainContent:'',
          trainReason:'',
          trainSite:'',//培训地点
          // shippers:[{'shipper':''}],
          trainer:[{type:1,depName:"",empName:'',empNameList:[]}],
          shippers:[{type:2,supplierName:[],participantsNum:'',}],
          img:[]
        },
        stepData:[
          {title:'张三发起',time:'2021-9-30 14:09:23',state:'',remark:''},
          {title:'财务部 张三通过',time:'2021-9-30 14:09:23',state:'success',remark:'原因xxxxxx'},
          {title:'技术部 李四拒绝',time:'2021-9-30 14:09:23',state:'failure',remark:'原因xxxxxx'},
          {title:'张三重新发起',time:'2021-9-30 14:09:23',state:'',remark:''},
        ],
        operationData:[
          {operateTime:'2021-8-31 15:49:58',operateType:'启用',account:'王三文',remark:'',size: 'large',},
          {operateTime:'2021-8-31 15:49:58',operateType:'禁用',account:'张三丰',remark:''},
          {operateTime:'2021-8-31 15:49:58',operateType:'添加',account:'赵兮雪',remark:''},
        ],
        dialogTitle:'',
        dialogVisible:false,
        addflag:false,
        addLoad:false,
        // 1 为添加 2 修改
        dilogNumber : 1,
        depNameList:[],
        empNameList:[],
        options2: [{
          value:'1',
          label: '公路供应商',
          cities: []
        }, {
          value:'2',
          label: '水路供应商',
          cities: []
        },{
          value:'2',
          label: '港口及其他',
          cities: []
        }],
        props: {
          value: 'label',
          label:'label',
          children: 'cities'
        },
        cascaderMap: new Map(),
        rules:{
          plan:{required: true, message: ' ', trigger: 'blur'},
          trainTime:[
            { required: true, message: '培训时间不能为空', trigger: 'blur' },
            // { min: 3, max: 9, message: '长度在 3 到 9 个字符', trigger: 'blur' }
          ],
          trainContent:{required: true, message: '请输入培训内容', trigger: 'blur'},
          trainReason:{required: true, message: '请输入培训原因', trigger: 'blur'},
          trainMode: { required: true, message: '培训方式不能为空', trigger: 'blur' },
          img:{ required: true, message: '请选择合同照片', trigger: 'blur' },
          supplierName:{ required: true, message: '请选择供应商名称', trigger: 'blur'},
          participantsNum:[
            {required: true, message: '请输入培训人员数量', trigger: 'blur'},
            {pattern:/^[0-9]*$/,message: '请输入数字'}
          ],
          depName:{required: true, message: '请选择所属部门', trigger: 'blur'},
          empName:{required: true, message: '请选择员工姓名', trigger: 'blur'},
          shipper:{
            required: true,
            validator: validshippers,
            trigger: "blur",
          },
          traine:{
            required: true,
            validator: validtraine,
            trigger: "blur",
          },

        }
      };

    },
    filters:{
      stats(val){
        let text=''
        switch (val) {
          case 1:
            text='待审核'
            break;
          case 2:
            text='已通过'
            break;
          case 3:
            text='已拒绝'
            break;
          case 4:
            text='已取消'
            break;
        }
        return text
      },
      formatTime(val){
        if(val){
          return formatTime(val, "yyyy-mm-dd hh:ii:ss")
        }else {
          return ''
        }


      }
    },
    computed:{
      stepState(){
        return function(state){
          switch(state) {
            case '':
              return 'wait'
            case 'success':
              return 'success'
            case 'failure':
              return 'error'
          }
        };
      },
    },
    created() {
      this.$nextTick(()=>{
        this.init()
      })
      for (let a in this.options2){
        console.log(a)
        this.cascaderMap.set(this.options2[a].label,this.options2[a].value)
      }
    },
    methods: {
      init(){
        this.uploadUrl = baseUrl + "/web/attachment/upload";
        this._trainRecordPageList()
      },
      async _trainRecordPageList(){
        let { startDate, endDate, status} = this.form
        this.tableLoad = true;
        let res = await  trainRecordPageList({
          ...this.form,
          state:status,
          startDate:startDate,
          endDate:endDate
        })
        this.tableLoad = false
        if (res.status !==0){
          return  this.$message.error(res.message)
        }
        this.TableDatas = res.data.records
        this.total = res.data.total
      },
      // 结束时间
      dateChange(val) {
        if(this.form.endDate&&this.form.startDate&&(this.form.endDate <= this.form.startDate)) {
          if(val == this.form.endDate) this.form.endDate = '';
          if(val == this.form.startDate) this.form.startDate = '';
          return this.$message.warning("结束日期必须大于开始日期！");
        }
      },
      async _qryDepartment(){
        let res =await qryDepartment({
          page: 1,
          rows: 10,
          isEnable:0
        })
        this.depNameList = res.data.records.map((item)=>{
          return{
            depNm:item.depNm,
            id:item.id
          }
        })
      },
      // 公路供应商
      async _highwayLineSelectList(){
        let res =await highwayLineSelectList()
        if (res.status !==0) return this.$message.error(res.message)
        return  res.data
      },
      // 水路供应商
      async _highwayLineSelectWaterSupplier(){
        let res = await highwayLineSelectWaterSupplier()
        if (res.status !==0) return this.$message.error(res.message)
        return res.data

      },
      //港口及其他
      async _shipDeployPublicSelectPort(){
        let res =await shipDeployPublicSelectPort()
        if (res.status !==0) return this.$message.error(res.message)
        return res.data

      },
      addBtn(){
        // 1 为添加 2 修改
        this.dilogNumber = 1
        this.dialogTitle = "新增托运商培训"
        this.addflag = true
        this.modifyData={
          trainTime:'',
          trainMode:'',
          trainContent:'',
          trainReason:'',
          trainer:[{type:1,depName:"",empName:'',empNameList:[]}],
          shippers:[{supplierName:'',participantsNum:'',}],
        }
        this._qryDepartment()

      },
      searchBtn(){
        this.form.page = 1;
        this._trainRecordPageList()
      },
      resetBtn(){
        for (const argumentsKey in this.form) {
          this.form[argumentsKey] = ""
        }
        this.form.page = 1
        this.form.rows = 10

      },
      contractSizeChange(row){
        this.form.rows=row;
        this._trainRecordPageList()
      },
      contractCurrentChange(page){
        this.form.page=page;
        this._trainRecordPageList()
      },
      tableIndexMethod(index) {
        return this.form.rows * (this.form.page - 1) + index + 1;
      },
      // 详情
      async detailClick(row){
        this.detailDialogVisible = true
        let res =await trainRecordDetail({id:row.id})
        if (res.status !==0) return  this.$message.error(res.message)
        this.detailData =res.data
        this.detailData.empName=''
        let {compTrainParticipatorList} =res.data
        compTrainParticipatorList.forEach((item,index)=>{
          this.detailData.empName += compTrainParticipatorList.length -1 ===index ? item.empName :item.empName +","
        })

      },
     async modifyClick(row){
        // 1 为添加 2 修改
        this.dilogNumber = 2
        this.dialogTitle = "修改托运商培训"
        this.addflag = true
        let res =await trainRecordDetail({id:row.id})
        if (res.status !==0) return  this.$message.error(res.message)
        let {compTrainParticipatorList,supplierTrainParticipatorList} =res.data
        //compTrainParticipatorList  我司培训人
        //supplierTrainParticipatorList 选择供应商
        this.modifyData ={
          ...row,
          // trainer:[{type:1,depName:"",empName:'',empNameList:[]}],
          // shippers:[{type:2,supplierName:[],participantsNum:'',}],
          //先判断是否时array  循环 我司培训人  通过部门查询人员
           trainer:compTrainParticipatorList instanceof Array? await Promise.all(compTrainParticipatorList.map(async (item)=>{
             let res2 =await empDeptListByEmpName({
               deptName:item.depName
             })
             //赛选数据
             let empNameList2 = res2.data.map((item)=>{
               return{
                 name:item.empName,
                 id:item.empId
               }
             })

             console.log(empNameList2)
             return{
               type:item.type,
               depName:{depNm:item.depName,id:item.depId},
               empName:{name:item.empName,id:item.empAccount},
               empNameList:await empNameList2
             }
           })) :[{type:1,depName:"",empName:'',empNameList:[]}],
          shippers:supplierTrainParticipatorList instanceof Array ?supplierTrainParticipatorList.map((item)=>{
            return{
              type:item.type,
              supplierName:[item.supplierTypeName,item.supplierName],
              participantsNum:item.participantsNum
            }
          }):[{type:2,supplierName:[],participantsNum:'',}]

        }
        await this._qryDepartment()
       console.log(this.modifyData.shippers,"shippers")

      },
      rejectClick(row){
        this.$confirm('确认要取消日常审核吗！', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          let res =await trainRecordCancelApplyFor({id:row.id})
          if (res.status !==0) return  this.$message.error(res.message)
          this.$message.success(res.message)
          this._trainRecordPageList()

        }).catch(() => {});
      },
      closeDialog(){
        this.dialogVisible = false
      },
      addClick(){
        this.$refs.ruleForm.validate(async (valid,val) => {
          // if(Object.keys(val).length === 1) valid=true;
          if (valid) {
            //数据处理
            let supplierName =''
            this.modifyData.shippers.forEach((item,index)=>{
              supplierName += this.modifyData.shippers.length -1 ===index? item.supplierName[1] :item.supplierName[1]+","
            })
            this.addLoad = true;
            let data={
              ...this.modifyData,
              supplierName:supplierName,
              compTrainParticipatorList:this.modifyData.trainer.map((item)=>{
                return{
                  type:1,
                  empAccount:item.empName.id,
                  empName:item.empName.name,
                  depId:item.depName.id,
                  depName:item.depName.depNm
                }
              }),
              supplierTrainParticipatorList:this.modifyData.shippers.map((item)=>{
                return{
                  type:2,
                  supplierType:this.cascaderMap.get(item.supplierName[0]),
                  supplierTypeName:item.supplierName[0],
                  supplierName:item.supplierName[1],
                  participantsNum:item.participantsNum
                }
              })
            }
            // 1 为添加 2 修改
            if (this.dilogNumber===1){
              console.log(data)
              let res =await  trainRecordAdd(data);
              this.addLoad = false;
              if (res.status !==0) return  this.$message.error(res.message)
              this.$message.success(res.message)
              console.log("添加")
            }else {
              let res =await  trainRecordUpdate(data);
              this.addLoad = false;
              if (res.status !==0) return  this.$message.error(res.message)
              this.$message.success(res.message)
              console.log(data)
              console.log("修改")
            }
            // this.$emit("addclose",false)
            this.dialogClose()
            await this._trainRecordPageList()
          } else {
            return false;
          }
        });
      },
      dialogClose(){
        this.modifyData ={
          trainTime:'',
          trainMode:'',
          trainContent:'',
          trainReason:'',
          trainer:[{depName:"",empName:''}],
          shippers:[{supplierName:'',participantsNum:'',}],
        }
        this.$refs.ruleForm.resetFields();
        this.addflag = false
      },
      arraySpanMethod({ row, column, rowIndex, columnIndex }){
        if (columnIndex === 0) {
          if (rowIndex % 2 === 0) {
            return {
              rowspan: 2,
              colspan: 1
            };
          } else {
            return {
              rowspan: 0,
              colspan: 0
            };
          }
        }
      },
      add_production(index){
        if (index ===1) this.modifyData.shippers.push({supplierName:'',participantsNum:'',})
        if (index === 2) this.modifyData.trainer.push({type:1,depName:"",empName:'',empNameList:[]})

      },
      deles_production(index,a){
        if (a ===1) this.modifyData.shippers.splice(index,1)
        if (a ===2) this.modifyData.trainer.splice(index,1)
      },
      async depNameChange(index,val){
        this.modifyData.trainer[index].empName =''
        console.log(val)
        let res =await empDeptListByEmpName({
          deptName:val.depNm
        })
       this.modifyData.trainer[index].empNameList= res.data.map((item)=>{
          return{
            name:item.empName,
            id:item.empId
          }
        })
      },
      handleItemChange(val){
        console.log(val)
        setTimeout(async _ => {
          if (val.indexOf('公路供应商') > -1) {
            let array =await this._highwayLineSelectList()
            this.options2[0].cities =array.map(item=>{
              return {
                label:item.name,
                value:item.id
              }
            })
          } else if (val.indexOf('水路供应商') > -1 ) {
            let array =await this._highwayLineSelectWaterSupplier()
            this.options2[1].cities = array.map(item=>{
              return{
                label:item.name,
                value:item.id,
              }
            })
          }else if (val.indexOf('港口及其他') > -1){
            let array = await this._shipDeployPublicSelectPort()
            this.options2[2].cities = array.map(item=>{
              return{
                label:item.supplier_name,
                value:item.id,
              }
            })
          }
        }, 300);
      },
      handleChange(index){
        // arr = this.$refs.areaCascader.currentLabels;
        // console.log(this.$refs.areaCascader)
        console.log(index)
      },


    },
  };
</script>



<style lang="scss" scoped>
  .consignor-train{
    /*width:100%;*/
    padding:20px 15px 0 25px;
    height: 100%;
    /*overflow: auto;*/
    .nav{
      /*width:100%;*/
      display: flex;
      /*align-items: center;*/
      /*height:30px;*/
      overflow: hidden;
      margin-bottom: 10px;
      .flex1{
        flex: 1;
      }
      .el-input{
        width: 150px;
      }
      .el-select{
        width: 150px;
      }
      ::v-deep {
        label.el-form-item__label {
          font-weight: 500;
          color: #101010;
        }
      }
    }
    .content{
      .tableContainer{
        margin-bottom: 25px;
        ::v-deep{
          .el-table .cell {
            padding: 0;
          }
          .el-table th{
            padding: 0;
          }
          .el-table td{
            padding: 0;
          }
          .el-table th>.cell{
            font-weight: 700!important;
          }
        }
      }
    }
    ::v-deep .detail{

      .line{
        width: 12px;
        height: 32px;
        background-color: rgba(51, 84, 131, 100);
        margin-right: 10px;
      }
      .line +span{
        font-size: 16px;
        color: rgba(51, 84, 131, 100);
        font-weight: 600;
      }
      width: 100%;
      padding: 10px 0 20px 20px;
      .baseInfo{
        display: flex;
        flex-direction: column;
        &Title{
          display:flex;
          align-items:flex-end;
          p{
            font-weight: 700;
            font-size: 14px;
            color: rgba(249, 166, 6);
            margin-left: 10px;
          }
        }
        &Content{
          display:flex;
          flex-direction: column;
          justify-content: space-between;
          padding:20px 23px 0 23px;
          font-size: 14px;
          .center-f{
            display: flex;
          }
          .el-form-item{
            margin-bottom: 2px;
            .el-form-item__label{
              /*color: #060606;*/
              font-weight: 700;
            }
          }


        }
      }
      .operation{
        display: flex;
        flex-direction: column;
        &Title{
          display:flex;
          align-items:flex-end;
          p{
            font-weight: 700;
            font-size: 14px;
            color: rgba(51, 136, 255, 1);
            margin-left: 10px;
          }
        }
        &Table{
          width:100%;
          margin-top: 10px;
          padding-right: 20px;
        }
      }
    }
    ::v-deep .add{

      .el-form-item__label{
        font-weight: 700;
      }
      .line{
        width: 12px;
        height: 32px;
        background-color: rgba(51, 84, 131, 100);
        margin-right: 10px;
      }
      .line +span{
        font-size: 16px;
        color: rgba(51, 84, 131, 100);
        font-weight: 600;
      }
      width: 100%;

      .baseInfo{
        display: flex;
        flex-direction: column;

        &Content{
          display:flex;
          flex-direction: column;
          justify-content: space-between;
          padding:20px 23px 0 23px;
          font-size: 14px;
          .yang{
            .el-form-item{
              .el-form-item__error{
                left: 40px;
              }
              margin-bottom:15px;

              .el-form-item__label{
                width: 150px !important;
                /*color: #060606;*/
              }
              .el-input{
                width: 430px;
              }
              .el-textarea{
                width: 430px;

              }
            }

          }


        }
        .tablesConter{
          .el-form-item{
            margin: 16px 7px;
          }
        }
        .append{
          color: #3A62D7;
          &:hover{
            cursor: pointer;
          }
      }


      }

      .btnContainer{
        width:100%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 13px;
        margin-top: 20px;
        button{
          margin: 0 15px;
        }
      }
    }
    ::v-deep{

      .el-dialog__header {
        padding: 9px 20px 9px;
        background: #335483;
      }

      .el-dialog__title {
        line-height: 24px;
        font-size: 14px;
        color: #FFFFFF;
      }

      .el-dialog__headerbtn {
        top: 9px;
      }

      .el-dialog__headerbtn .el-dialog__close {
        color: #fff;
        font-size: 25px;
      }

      .el-dialog__body {
        padding: 0;
        overflow: auto;
        max-height: 75vh;
        color: #606266;
      }

    }

  }

::v-deep {
  .el-form--inline .el-form-item {
    margin-bottom: 5px;
  }
}
</style>
